<div class="filters-skeleton">
  <div class="ng-flex">
    <div class="filter skeleton-block" style="width: 118px"></div>
    <div class="filter skeleton-block" style="width: 163px"></div>
  </div>
</div>
